export default {"src":"/_next/static/media/Arrow Down.1ce81ccc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};